<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.set_limits.form.refund_limit')"
            :is-required="true"
            :error="errors.refund_limit"
            :hint="__('settings.set_limits.form.refund_limit_hint')"
        >
            <DInput
                id="refund_limit"
                v-model="form.refund_limit"
                :placeholder="__('settings.set_limits.form.refund_limit')"
                :is-valid="isFormFieldValid('refund_limit')"
                type="number"
                min="0"
                max="4294967295"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.set_limits.form.contract_free_months')"
            :is-required="true"
            :error="errors.contract_free_months"
            :hint="__('settings.set_limits.form.contract_free_months_hint')"
        >
            <DInput
                id="contract_free_months"
                v-model="form.contract_free_months"
                :placeholder="__('settings.set_limits.form.contract_free_months')"
                :is-valid="isFormFieldValid('contract_free_months')"
                type="number"
                min="0"
                max="4294967295"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.set_limits.form.maximum_discount')"
            :is-required="true"
            :error="errors.maximum_discount_percentage"
            :hint="__('settings.set_limits.form.maximum_discount_hint')"
        >
            <DInput
                id="maximum_discount_percentage"
                v-model="form.maximum_discount_percentage"
                :placeholder="__('settings.set_limits.form.maximum_discount')"
                :is-valid="isFormFieldValid('maximum_discount_percentage')"
                type="number"
                min="1"
                max="100"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <WarningModal
            v-if="showWarningModal"
            :show-modal="showWarningModal"
            @confirm-modal="confirm"
            @close-modal="close"
        />
    </DForm>
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import WarningModal from '~@/Components/Settings/Permissions/SetLimitSettings/WarningModal'

const props = defineProps({
    setLimitSettings: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const showWarningModal = ref(false)

const emit = defineEmits(['form-submitted'])

const form = useForm({
    refund_limit: props.setLimitSettings?.refund_limit ?? null,
    contract_free_months: props.setLimitSettings?.contract_free_months ?? null,
    maximum_discount_percentage: props.setLimitSettings?.maximum_discount_percentage ?? 100
})

function submitForm () {
    if (form.isDirty === true) {
        showWarningModal.value = true
    } else {
        confirm()
    }
}
function confirm () {
    showWarningModal.value = false
    emit('form-submitted', form)
}
function close () {
    showWarningModal.value = false
}
</script>

<style scoped>

</style>
